import { AppSettingEditor } from "../../helper/AppSettingditor";

const PrivacyPolicy = () => <AppSettingEditor title="Privacy Policy" settingCode="AP-009" pageId={9}/>;
export default PrivacyPolicy;